import Statement from './Statement.vue';

export * from './consts';
export default Statement;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/statement/index.ts